// 移交派发的业务类型
export const businessTypeByTransfer = {
  customer: 10,
  enterprise: 20,
  clueOrHighSea: 30,
  customerBusinessCenter: 40,
  enterpriseBusinessCenter: 50,
  recycle: 60
}

/**
 * @description: 场景类型
 */
export enum SceneTypeEnum {
  ADD_FORM = 1, // 新增表单
  APPLY_DETAIL, // 应用详情
  FLOW_DETAIL // 审批流程详情
}

/**
 * @description: 自定义配置-动态参数选项
 */
export enum DynamicConfigEnum {
  ADD_CONFIG = 1, // 当前新增数据的用户(或所属的部门)
  EDIT_CONFIG // 当前修改数据的用户(或所属的部门)
}
